import values from 'lodash/values';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getCategoricalSummary } from 'store/dataset/summary';
import { getRelativeFrequencySammaryByFrequencySummary } from 'calculators/graphicalStatistics/frequencyTable';

import PieChart from 'components/PieChart';

class PieChartContainer extends React.Component {

  get levelsSummary () {
    const { parameter, summary, isTypeOfGraphsFrequency } = this.props;
    const frequencySummary = values(summary[parameter].levels);

    if (isTypeOfGraphsFrequency) {
      return frequencySummary;
    }
    return getRelativeFrequencySammaryByFrequencySummary(frequencySummary);
  }

  render () {
    return (
      <PieChart sectors={this.levelsSummary} />
    );
  }
}

PieChartContainer.propTypes = {
  parameter: PropTypes.string.isRequired,
  summary: PropTypes.object.isRequired,
  isTypeOfGraphsFrequency: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  summary: getCategoricalSummary(state)
});

export default connect(mapStateToProps)(PieChartContainer);
